import _slicedToArray from "/codebuild/output/src182831320/src/scottschedule/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useLayoutEffect as t } from "@radix-ui/react-use-layout-effect";
import * as e from "react";
var r = e["useId".toString()] || function () {};
var n = 0;
export function useId(o) {
  var _e$useState = e.useState(r()),
    _e$useState2 = _slicedToArray(_e$useState, 2),
    u = _e$useState2[0],
    i = _e$useState2[1];
  return t(function () {
    o || i(function (t) {
      return null != t ? t : String(n++);
    });
  }, [o]), o || (u ? "radix-".concat(u) : "");
}
export function IdProvider(_ref) {
  var t = _ref.children;
  return e.useEffect(function () {
    0;
  }, []), /*#__PURE__*/e.createElement(e.Fragment, null, t);
}